"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubForm = exports.SUB_FORM_BORDER_WIDTH = void 0;
var tslib_1 = require("tslib");
var pdfTheme_1 = require("../pdfTheme");
exports.SUB_FORM_BORDER_WIDTH = 2;
var SubForm = /** @class */ (function () {
    function SubForm(subFormTitle, subFormSubTitle, content) {
        this.subFormTitle = subFormTitle;
        this.subFormSubTitle = subFormSubTitle;
        this.nodes = [];
        this.nodes = tslib_1.__spreadArray([], content, true);
    }
    SubForm.prototype.exportContent = function () {
        return {
            layout: {
                hLineWidth: function () { return 0; },
                vLineWidth: function () { return 0; },
                hLineColor: function () { return pdfTheme_1.pdfTheme.background.light; },
                vLineColor: function () { return pdfTheme_1.pdfTheme.background.light; },
                paddingLeft: function () { return pdfTheme_1.pdfTheme.spacing.large; },
                paddingRight: function () { return 0; },
                paddingTop: function () { return pdfTheme_1.pdfTheme.spacing.default; },
                paddingBottom: function (i) { return i === 0 ? pdfTheme_1.pdfTheme.spacing.default : 0; }
            },
            style: ['subForm'],
            table: {
                widths: ['*'],
                body: [
                    [
                        {
                            fillColor: pdfTheme_1.pdfTheme.background.light,
                            columnGap: 3,
                            columns: [
                                {
                                    text: "".concat(this.subFormTitle, ":"),
                                    width: 'auto',
                                    style: ['subFormTitle']
                                },
                                {
                                    text: this.subFormSubTitle,
                                    style: ['subFormSubTitle']
                                }
                            ]
                        }
                    ],
                    [
                        {
                            stack: this.nodes.map(function (node) { return node.exportContent(); }),
                            marginLeft: pdfTheme_1.pdfTheme.spacing.default
                        }
                    ]
                ]
            }
        };
    };
    SubForm.prototype.exportStyles = function () {
        return {
            subForm: {
                marginBottom: pdfTheme_1.pdfTheme.spacing.small
            },
            subFormTitle: {
                fontSize: pdfTheme_1.pdfTheme.font.size.default,
                bold: true
            },
            subFormSubTitle: {
                fontSize: pdfTheme_1.pdfTheme.font.size.default
            }
        };
    };
    return SubForm;
}());
exports.SubForm = SubForm;
//# sourceMappingURL=SubForm.js.map